import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BookHouseOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M6 19H21V1H6C4.3457 1 3 2.3457 3 4V20C3 21.6543 4.3457 23 6 23H19V21H6C5.44824 21 5 20.5518 5 20C5 19.4482 5.44824 19 6 19ZM5 4C5 3.44824 5.44824 3 6 3H19V17H6C5.64941 17 5.3125 17.0606 5 17.1709V4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8 13H10V9.04979L12 7.13768L14 9.04979V13H16V8.19433L13.1543 5.47363C12.498 4.84863 11.5068 4.8457 10.8447 5.47461L8 8.19434V13Z",
    fill: "currentColor"
  }));
}